module.exports = __webpack_public_path__ + "img/语音ai能力.2e35bbc0.jpg";